window.cardProductFunc = function () {

  // ─── Media grouping ──────────────────────────────────────────────────────────

  const groupMediaByColor = (productData) => {
    const colorGroups = { noColor: [] };
    const colorOptionIndex = productData.options
      .map((o) => o.toLowerCase())
      .indexOf('color');

    productData.media.forEach((media) => {
      if (colorOptionIndex !== -1 && media.alt) {
        const key = media.alt.toLowerCase().trim();
        if (!colorGroups[key]) colorGroups[key] = [];
        colorGroups[key].push(media);
      } else {
        colorGroups.noColor.push(media);
      }
    });

    return colorGroups;
  };

  // ─── Picture HTML builder ────────────────────────────────────────────────────

  const makePictureHtml = (media, cssClass, isEager = false) => {
    if (!media) return '';
    const loading = isEager ? '' : 'loading="lazy" decoding="async"';
    return `
      <picture>
        <source media="(max-width:600px)"  srcset="${media.src}?width=300" ${loading}>
        <source media="(max-width:1600px)" srcset="${media.src}?width=500" ${loading}>
        <source media="(max-width:2000px)" srcset="${media.src}?width=800" ${loading}>
        <img
          src="${media.src}?width=800"
          class="${cssClass}"
          alt="${media.alt || ''}"
          ${loading}
        >
      </picture>`;
  };

  // ─── Video HTML builder (for hover-media that is a video) ──────────────────

  const makeVideoHtml = (media, cssClass) => {
    if (!media || !media.sources || !media.sources.length) return '';
    const mp4Source =
      media.sources.find((s) => s.format === 'mp4' && s.mime_type === 'video/mp4') ||
      media.sources[0];

    return `
      <div class="product-card__hover-video-wrapper">
        <video
          class="${cssClass}"
          src="${mp4Source.url}"
          muted
          loop
          playsinline
          preload="metadata"
        ></video>
      </div>`;
  };

  // ─── Image swap ──────────────────────────────────────────────────────────────

  const updateImagesForColor = (card, productData, colorValue, selectedVariant) => {
    const imageLink = card.querySelector('.product-card__image-link.js-product-link');
    if (!imageLink) return;

    // Never touch video cards
    if (imageLink.classList.contains('has-video')) return;

    const colorGroups = groupMediaByColor(productData);
    const colorKey    = (colorValue || '').toLowerCase().trim();
    const matched     = colorGroups[colorKey] || [];

    let mainMedia  = null;
    let hoverMedia = null;

    if (matched.length > 1) {
      mainMedia  = matched[0];
      hoverMedia = matched[1];
    } else if (matched.length === 1) {
      mainMedia  = matched[0];
      hoverMedia = null;
    } else if (selectedVariant && selectedVariant.featured_media) {
      let mediaIndex = 0;
      for (let i = 0; i < productData.media.length; i++) {
        if (productData.media[i].id === selectedVariant.featured_media.id) {
          mediaIndex = i;
          break;
        }
      }
      mainMedia  = productData.media[mediaIndex] || null;
      hoverMedia = productData.media[mediaIndex + 1] || null;
    } else {
      mainMedia  = productData.media[0] || null;
      hoverMedia = productData.media[1] || null;
    }

    if (hoverMedia) {
      imageLink.classList.add('has-multiple-media');
    } else {
      imageLink.classList.remove('has-multiple-media');
    }

    const hoverHtml =
      hoverMedia && hoverMedia.media_type === 'video'
        ? makeVideoHtml(hoverMedia, 'product-card__hover-video')
        : makePictureHtml(hoverMedia, 'product-card__hover-image', false);

    imageLink.innerHTML =
      makePictureHtml(mainMedia, 'product-card__primary-image', true) + hoverHtml;
  };

  // ─── Price update ────────────────────────────────────────────────────────────

  const formatMoney = (cents) => {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  };

  const updatePrice = (card, productData, selectedVariant) => {
    const priceWrapper = card.querySelector('.price-wrapper');
    if (!priceWrapper) return;

    const price          = selectedVariant.price;
    const compareAtPrice = selectedVariant.compare_at_price;

    let priceHtml = '';

    if (compareAtPrice && compareAtPrice > price) {
      const savedCents      = compareAtPrice - price;
      const savedPercentage = Math.round((savedCents * 100) / compareAtPrice);

      priceHtml = `
        <span class="price-regular">
          <span class="price-standard">${formatMoney(price)}</span>
          <span class="price-sale">${formatMoney(compareAtPrice)}</span>
          <div class="saved__money">Save ${savedPercentage}%</div>
        </span>`;
    } else {
      priceHtml = `
        <span class="price-regular">
          <span class="price-standard">${formatMoney(price)}</span>
        </span>`;
    }

    priceWrapper.innerHTML         = priceHtml;
    priceWrapper.dataset.variantId = selectedVariant.id;
  };

  // ─── Color name update ───────────────────────────────────────────────────────

  const updateColorName = (card, productData, selectedVariant) => {
    const colorNameEl = card.querySelector('.pd-selected-color-value');
    if (!colorNameEl) return;

    const colorOptionIndex = productData.options
      .map((o) => o.toLowerCase())
      .indexOf('color');

    if (colorOptionIndex !== -1 && selectedVariant.options[colorOptionIndex]) {
      colorNameEl.textContent = selectedVariant.options[colorOptionIndex];
    }
  };

  // ─── Link updater ────────────────────────────────────────────────────────────

  const updateProductLinks = (card, variantUrl) => {
    card.querySelectorAll(
      'a.absolute-link, h3.--product-title a, .product-card__image-link.js-product-link'
    ).forEach((link) => {
      link.href = variantUrl;
    });
  };

  // ─── Color swatch init ───────────────────────────────────────────────────────

  const initColorSwatches = (card) => {
    const jsonEl = card.querySelector('[data-product-json]');
    if (!jsonEl) return;

    let productData;
    try {
      productData = JSON.parse(jsonEl.textContent);
    } catch (e) {
      console.error('Error parsing product JSON:', e);
      return;
    }

    const swatches = card.querySelectorAll('.--color-swatch');
    if (!swatches.length) return;

    swatches.forEach((swatch) => {
      swatch.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const targetUrl = swatch.getAttribute('href') || swatch.dataset.url || '';

        const variantId = new URLSearchParams(targetUrl.split('?')[1] || '').get('variant');
        const selectedVariant =
          productData.variants.find((v) => String(v.id) === String(variantId)) ||
          productData.variants[0];

        if (!selectedVariant) return;

        const colorOptionIndex = productData.options
          .map((o) => o.toLowerCase())
          .indexOf('color');
        const colorValue =
          colorOptionIndex !== -1 ? selectedVariant.options[colorOptionIndex] : '';

        const variantUrl = targetUrl || `/products/${productData.handle}?variant=${selectedVariant.id}`;

        // 1. Swap images
        updateImagesForColor(card, productData, colorValue, selectedVariant);

        // 2. Update price
        updatePrice(card, productData, selectedVariant);

        // 3. Update displayed color name
        updateColorName(card, productData, selectedVariant);

        // 4. Update all hrefs
        updateProductLinks(card, variantUrl);

        // 5. Update selected swatch state
        swatches.forEach((s) => s.classList.remove('color-swatch--selected'));
        swatch.classList.add('color-swatch--selected');
      });
    });

    // Note: first swatch is marked color-swatch--selected in Liquid at render time
  };

  // ─── Video controls (metafield featured video) ──────────────────────────────

  const initVideoControls = (card) => {
    const videoWrapper = card.querySelector('.product-card__video-wrapper');
    if (!videoWrapper) return;

    const video        = videoWrapper.querySelector('.product-card__primary-video');
    const toggleButton = videoWrapper.querySelector('.product-card__video-toggle');
    if (!video || !toggleButton) return;

    const updateButtonState = () => {
      toggleButton.classList.toggle('paused', video.paused);
    };

    const togglePlayPause = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (video.paused) {
        video.play().catch((err) => console.error('Error playing video:', err));
      } else {
        video.pause();
      }
    };

    toggleButton.addEventListener('click', togglePlayPause);
    video.addEventListener('pause',   updateButtonState);
    video.addEventListener('play',    updateButtonState);
    video.addEventListener('playing', updateButtonState);

    setTimeout(updateButtonState, 100);
  };

  // ─── Hover video (hover_media that is a video) ──────────────────────────────

  const initHoverVideo = (card) => {
    const imageLink = card.querySelector('.product-card__image-link.js-product-link');
    if (!imageLink) return;

    imageLink.addEventListener('mouseenter', () => {
      const video = imageLink.querySelector('.product-card__hover-video');
      if (video) video.play().catch(() => {});
    });

    imageLink.addEventListener('mouseleave', () => {
      const video = imageLink.querySelector('.product-card__hover-video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });
  };

  // ─── Main ────────────────────────────────────────────────────────────────────

  const processProductCards = () => {
    document.querySelectorAll('.--product-card-v3').forEach((card) => {
      if (card.dataset.initialized === 'true') return;
      card.dataset.initialized = 'true';

      try {
        initColorSwatches(card);
        initVideoControls(card);
        initHoverVideo(card);
      } catch (error) {
        console.error('Error processing product card:', error);
      }
    });
  };

  if (document.readyState !== 'loading') {
    processProductCards();
  } else {
    document.addEventListener('DOMContentLoaded', processProductCards);
  }
};

window.cardProductFunc();